import { PathwaysExecutionData } from '@ispm-client/modules/pathways';
import { Action } from '@ngrx/store';

export enum LoadPathwaysActionTypes {
  HANDLE_FETCHED_BY_KEYS_ACTION = '[Pathways] Handle pathways data fetched by keys',
  CONFIGURE_PROCESS_EXECUTOR_MODULE = '[Pathways] Configure bpmn module'
}

export class HandlePathwaysDataFetchedByKeysAction implements Action {
  readonly type = LoadPathwaysActionTypes.HANDLE_FETCHED_BY_KEYS_ACTION;
  constructor(public payload: { data: PathwaysExecutionData}) { }
}

export class ConfigureProcessExecutorModuleAction implements Action {
  readonly type = LoadPathwaysActionTypes.CONFIGURE_PROCESS_EXECUTOR_MODULE;
}

export type LoadPathwaysActions = HandlePathwaysDataFetchedByKeysAction | ConfigureProcessExecutorModuleAction;
